<template>
  <fragment>
    <v-list-item-content>
      <v-text-field
        name="fullname"
        v-if="form"
        v-model="form.name"
        v-bind="$pr.textField"
        :label="$t('Name')"
        hide-details="auto"
        @input="
          hasUpdatedName = true;
          disabled = false;
        "
      >
        <!-- <template #append-outer></template> -->
      </v-text-field>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        :disabled="disabled"
        class="ma-1"
        @click="submitName()"
        v-if="hasUpdatedName"
        color="success"
        :loading="nameLoading"
      >
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </v-list-item-action>
  </fragment>
</template>

<script>
import Form from "@/landing/common/form";

export default {
  mounted() {
    this.form = new Form(
      { name: this.user.name },
      {
        url: "api/user/" + this.user.id,
        method: "put",
      },
      this
    );
  },
  data() {
    return {
      form: null,
      nameLoading: false,
      hasUpdatedName: false,
      disabled: false,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    async submitName() {
      if (this.nameLoading) return;
      this.nameLoading = true;
      try {
        const response = await this.form.submit();
        this.$store.commit("SET", { user: response.data.item });
        this.disabled = true;
        // setTimeout(() => {
        //   this.hasUpdatedName = false;
        //   this.disabled = false;
        // }, 5000);
      } catch (error) {
        console.log(error);
      } finally {
        this.nameLoading = false;
      }
    },
  },
};
</script>
